import { alertController, loadingController, toastController } from "@ionic/vue";
import { NativeAudio } from '@capacitor-community/native-audio';
import { Preferences } from "@capacitor/preferences";

const volume = 0.4;

export type SearchParams = {
  label: string,
  value: any,
}

export const presentLoading = async (message: string) => {
    const loading = await loadingController.create({
      message: message,
      translucent: true,
      backdropDismiss: false,
    });
    await loading.present();
};
  
export const dismissLoading = async () => {
  await loadingController.dismiss();
};

export const stopAllSounds = () => {
  ['background_music', 'click', 'success', 'invalid', 'congrat'].forEach(assetId => {
    stopSound(assetId);
  });
};

export const playSound = async (assetId: string) =>  {
  const { value } = await Preferences.get({ key: 'SOUND_STATE' });
  const soundActivated = Boolean(Number(value));

  if(! soundActivated) return;

  await NativeAudio.play({ assetId });
  await NativeAudio.setVolume({ assetId, volume });
}

export const stopSound = async (assetId: string) => {
  await NativeAudio.stop({ assetId });
}

export const buttonTap = () => {
  playSound('click');
}

export const successSound = () => {
  playSound('success');
}

export const failureSound = () => {
  playSound('invalid');
};

export const congrat = () => {
  playSound('congrat');
}

export const startBackgroundMusic = () => {
  playSound('background_music');
};

export const stopBackgroundMusic = () => {
  stopSound('background_music');
};

interface AlertOptions {
  type?: string;
  color?: string;
  confirmHandler?: () => void;
}

export const alertMessage = async (message: string, options: AlertOptions = {}) => {
  const defaultOptions = {
    type: "alert",
    color: "success",
    buttons: [
      {
        text: "OK",
        role: "confirm",
        handler: () => {
          if (options.confirmHandler) {
            options.confirmHandler();
          }
        },
      },
    ],
    ...options,
  };

  if (defaultOptions.type === "alert") {
    const alert = await alertController.create({
      message: message,
      buttons: defaultOptions.buttons,
    });
    await alert.present();
  } else if (defaultOptions.type === "toast") {
    const toast = await toastController.create({
      message: message,
      duration: 1500,
      position: "bottom",
      color: defaultOptions.color,
    });
    await toast.present();
  }
};


export const toLabelValue = (object: any) => {
  return Object.entries(object).map(([value, label]) => ({ label, value }));
}

export const findKeyByValue = (items: any[], value: string) => {
  const lowercasedValue = removeAccents(value.toLowerCase());
  
  return items.filter((item: SearchParams) => {
    const valueToCompare = removeAccents(item.label.toLowerCase());
    return valueToCompare.includes(lowercasedValue);
  });
}

export const removeAccents = (str: string) => {
  return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
}

export const makeid = (length: number) => {
  let result = "";
  const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  const charactersLength = characters.length;
  let counter = 0;
  while (counter < length) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
    counter += 1;
  }
  return result;
}